import React from 'react';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { TextButton } from 'wix-ui-tpa/cssVars';
import settingsParams from '../../../settingsParams';
import stylesParams from '../../../stylesParams';
import { TpaPage, PromptAuthPageCallback } from '../../types';
import { ForcedState, TEXT_DIRECTION } from '../../../../../constants';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { classes } from '../../../../common/FormSection/FormSection.st.css';

interface ResetPasswordLinkProps {
  isEditor?: boolean;
  isPreview?: boolean;
  forceView?: ForcedState;
  promptAuthPage: PromptAuthPageCallback;
  allowPostAuthRedirect?: boolean;
}

export const ResetPasswordLink: React.FC<ResetPasswordLinkProps> = ({
  isEditor = false,
  isPreview = false,
  forceView,
  promptAuthPage,
  allowPostAuthRedirect = false,
}) => {
  const settings = useSettings();
  const styles = useStyles();
  const { isRTL } = useEnvironment();

  const isResetPasswordLinkVisible = styles.get(
    stylesParams.showForgotPasswordLink,
  );

  const text = settings.get(settingsParams.resetPasswordLinkText);

  if (!isResetPasswordLinkVisible || !text) {
    return null;
  }

  return (
    <div className={classes.resetPasswordLink}>
      <TextButton
        data-hook="login-reset-password"
        className={`${classes.resetPasswordLinkText} ${
          isEditor && forceView === ForcedState.FORGOT_PASSWORD_HOVER
            ? classes.resetPasswordLinkHover
            : ''
        }`.trim()}
        href="#"
        // Prevent focus change on pointer down so the input doesn't blur before this action
        onPointerDown={isPreview ? undefined : (e) => e.preventDefault()}
        onClick={
          isPreview
            ? undefined
            : () => {
                // Forward the post-login-redirect flag so it survives the forgot-password
                // detour: thunderbolt relays it to the reopened login dialog.
                promptAuthPage(TpaPage.FORGOT_PASSWORD, {
                  isCloseable: true,
                  allowPostAuthRedirect,
                });
              }
        }
        dir={isRTL ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR}
      >
        {text}
      </TextButton>
    </div>
  );
};
